var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isMobile === false)?_c('laptop',{attrs:{"browser":_vm.browser,"isWindows":_vm.isWindows}}):_vm._e(),(_vm.isMobile === true)?_c('mobile',{attrs:{"browser":_vm.browser}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }